import InputField from './inputField';

export default class TextField extends InputField {
  getType() {
    return 'text';
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/forms/textField.jsx
 **/